import "./Header.scss";
import logo from "/app-logo.png";
import { Link } from "react-router-dom";
import { ENVIRONMENT } from "~shared/constants.ts";
import { useIntl } from "react-intl";
import { UserProfile } from "./components/UserProfile/UserProfile.tsx";
import { NotificationsInfo } from "./components/NotificationsInfo/NotificationsInfo.tsx";
import { AppSettings } from "./components/AppSettings/AppSettings.tsx";

export const Header = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="app-header">
      <div className="app-info">
        <div className="app-logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className="app-title">
          {`${formatMessage({ id: "pageTitles.applicationName" })} - ${ENVIRONMENT}`}
        </div>
      </div>
      <div className="user-info">
        <UserProfile />
        <NotificationsInfo />
        <AppSettings />
      </div>
  </div>)
}